import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../routes/PathLink'
import { Table } from "../components/ui/table";
import { Pagination, Select } from "antd";
import { amount_format } from "../components/config/Common";

const ShTable = (props) => {	
    const {data, yearlist, pageSize, isLoading, paginatorInfo, totalPages} = props
    console.log('data props===',data)

    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
    id: `sk-${i}`,
    _isSkeleton: true
    }));

    const baseColumns = [
    
    {
      title: 'Name',
      dataIndex: 'comp_name',
      key: 'comp_name',
      align: 'left',
      width: 200,
     render: (comp_name, record) => (
  <div className="min-w-[200px]">
    {record?.comp_name ? (
      <Link
        className="text-accent hover:underline"
        to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record.symbol}`}
      >
        <p className="text-sm md:text-base font-semibold text-gray-900 leading-snug">
          {record.comp_name}
        </p>
        <p className="text-xs text-gray-500 uppercase">
          {record.symbol}
        </p>
      </Link>
    ) : null}
  </div>
)
    },
 
];

const tableData = useMemo(() => {
  if (isLoading) return skeleton;

  const rawData = Array.isArray(data)
    ? data
    : Object.values(data || {});

  return rawData.map(item => {
    let holding = {};

    try {
      holding = item.holding_info ? JSON.parse(item.holding_info) : {};
    } catch (e) {
      holding = {};
    }

    return {
      ...item,
      ...holding, // ✅ flatten JSON into root
    };
  });
}, [data, isLoading, skeleton]);



const dynamicColumns = useMemo(() => {
  if (!Array.isArray(tableData) || tableData.length === 0) return [];

const monthOrder = {
  Jan: 1, Feb: 2, Mar: 3, Apr: 4,
  May: 5, Jun: 6, Jul: 7, Aug: 8,
  Sep: 9, Oct: 10, Nov: 11, Dec: 12
};

const keys = Object.keys(tableData[0])
  .filter(key => key.startsWith('percent_holding_'))
  .sort((a, b) => {
    const parse = (key) => {
      const clean = key.replace('percent_holding_', '');

      // support multiple formats: 2025_Aug, 2025 Aug, 2025-Aug
      const parts = clean.split(/[_\-\s]/);

      const year = parts[0];
      const month = parts[1]?.substring(0, 3); // safely take first 3 chars

      return new Date(year, monthOrder[month] || 0);
    };

    return parse(a) - parse(b);
  });
  const latestKey = keys[keys.length - 1];

  return keys.map(key => ({
    title: (
     <div className="text-xs font-semibold">
    {(() => {
      const clean = key.replace('percent_holding_', '');
      const parts = clean.split(/[_\-\s]/);

      const year = parts[0];
      const month = parts[1]?.substring(0, 3);

      if (!year || !month) return '-';

      return `${month} '${year.slice(-2)}`;
    })()}
  </div>
    ),
    dataIndex: key,
    key,
    align: 'right',
    width: 110,
    className: key === latestKey ? 'bg-gray-50 font-semibold' : '',
    render: (value) => {
      if (!value) return <span className="text-gray-300">–</span>;

      return (
        <span className="text-sm font-medium">
          {value}%
        </span>
      );
    }
  }));
}, [tableData]);


const columns = useMemo(() => {
  return [...baseColumns, ...dynamicColumns];
}, [baseColumns, dynamicColumns]);

    const onPagination = (current) => {
        //console.log("current Page",current);
        props.onPagination(current);
    }
    const onPageSize = (value) => {
        props.onPageSize(value)
    }

   

    return (
        <>
            {paginatorInfo &&<div className="mt-5 text-sm text-gray-500">
                  {paginatorInfo?.total} results found: Showing page {paginatorInfo?.currentPage} of {totalPages}
                </div>}
            <div className="my-6 overflow-hidden rounded shadow">
            <Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : tableData}
                scroll={{ x: 900 }}
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            </div>
            <div className="w-full flex justify-start mb-5">
                {!!paginatorInfo?.total && ( 
                <div className="w-full flex items-left justify-between flex-wrap">
                    <div>
                    <Pagination
                    total={paginatorInfo.total}
                    current={paginatorInfo.currentPage}
                    pageSize={paginatorInfo.perPage}
                    onChange={onPagination}
                    showSizeChanger={false}
                    className="flex-wrap"
                    />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="px-5 text-sm text-gray-500">Results Per Page</div>
                        <Select
                            value={pageSize}
                            onChange={onPageSize}
                            options={[
                                { value: 10, label: "10 rows" },
                                { value: 25, label: "25 rows" },
                                { value: 50, label: "50 rows" },
                                { value: 100, label: "100 rows" },
                                
                            ]}
                            style={{ width: 130 }}
                        />
                    </div>
                </div>
                )} 
            </div>
        </>    
    )
}

export default ShTable;